import { FC } from 'react';
import FormGroup from 'components/form/FormGroup';
import Form from 'components/form/Form';
import { useTranslation } from 'react-i18next';
import { IInputs } from './types';

interface IProps {
  title: string;
  methods: any;
  handleSubmit: (data: IInputs) => void;
  btnLabel: string;
  isEditMode?: boolean;
}

const GroupForm: FC<IProps> = ({ title, methods, handleSubmit, btnLabel }: IProps) => {
  const { t } = useTranslation();
  return (
    <Form
      title={title}
      methods={methods}
      onSubmit={handleSubmit}
      btnLabel={btnLabel}
      isHorizontal
    >
      <FormGroup
        controlId="formGroupName"
        label={t('structure.groups.name')}
        type="text"
        name="name"
        isRequired
        isHorizontal
      />
      <FormGroup
        controlId="formGroupAddress"
        label={t('structure.groups.address')}
        type="text"
        name="address"
        isHorizontal
      />
      <FormGroup
        controlId="formGroupDescription"
        label={t('structure.groups.description')}
        type="text"
        name="description"
        isHorizontal
      />
      {
        // TODO: add when visible_to_candidates should be rendered (Maybe check feature flag?)
      }
      <FormGroup
        controlId="formGroupVisibleToCandidates"
        label={t('structure.groups.visibleToCandidates')}
        checkType="switch"
        name="visible_to_candidates"
        isHorizontal
      />
    </Form>
  );
};

export default GroupForm;
